import React, { useId, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faQuestion } from "@fortawesome/free-solid-svg-icons";
import "./Faqs.css";

const Faqs = ({ data = [], title = "Frequently Asked Questions" }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const componentId = useId();

  const faqs = Array.isArray(data) ? data : [];

  const toggleAnswer = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  if (!faqs.length) {
    return null;
  }

  return (
    <section className="faq-section" aria-labelledby={`${componentId}-title`}>
      <div className="faq-section__container">
        <header className="faq-section__header">
          <p className="faq-section__eyebrow">
            <span aria-hidden="true" />
            Need clarity?
          </p>

          <h2 id={`${componentId}-title`}>{title}</h2>

          <p className="faq-section__intro">
            Find clear answers to common questions about our services, delivery
            process, technology, and long-term support.
          </p>
        </header>

        <div className="faq-section__list">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const questionId = `${componentId}-question-${index}`;
            const answerId = `${componentId}-answer-${index}`;

            return (
              <article
                key={faq.id ?? faq.question ?? index}
                className={`faq-item ${isOpen ? "is-open" : ""}`}
              >
                <h3 className="faq-item__heading">
                  <button
                    id={questionId}
                    type="button"
                    className="faq-item__question"
                    onClick={() => toggleAnswer(index)}
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                  >
                    <span className="faq-item__number" aria-hidden="true">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <span className="faq-item__question-text">
                      {faq.question}
                    </span>

                    <span className="faq-item__toggle" aria-hidden="true">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </button>
                </h3>

                <div
                  id={answerId}
                  className="faq-item__answer-wrapper"
                  role="region"
                  aria-labelledby={questionId}
                  aria-hidden={!isOpen}
                >
                  <div className="faq-item__answer">
                    <span className="faq-item__answer-icon" aria-hidden="true">
                      <FontAwesomeIcon icon={faQuestion} />
                    </span>

                    <p>{faq.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
